import { render, staticRenderFns } from "./mOtpLayout.vue?vue&type=template&id=66a291ba"
import script from "./mOtpLayout.vue?vue&type=script&lang=js"
export * from "./mOtpLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a291ba')) {
      api.createRecord('66a291ba', component.options)
    } else {
      api.reload('66a291ba', component.options)
    }
    module.hot.accept("./mOtpLayout.vue?vue&type=template&id=66a291ba", function () {
      api.rerender('66a291ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/mOtpLayout.vue"
export default component.exports